import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import Footer from './Footer'
import Header from './Header'
import Progress from '../components/Progress'
import { useCompanySpaces, useSpaces } from '../queries/useCompanyQueries'

const Layout = ({ children }: { children: ReactNode }) => {
  const { data: companyData, isLoading: isLoadingCompany } = useCompanySpaces()
  const { data: areasData, isLoading: isLoadingSpaces } = useSpaces()

  const isLoading = isLoadingCompany || isLoadingSpaces

  return (
    <>
      {isLoading ? (
        <Progress />
      ) : areasData?.status === 200 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
          }}
        >
          <Header />
          <Box
            sx={{
              flexGrow: 1,
              backgroundColor: 'background.default',
              paddingTop: '75px',
              paddingBottom: '60px',
              height: '100%'
            }}
          >
            {children}
          </Box>
          <Footer />
        </Box>
      ) : (
        <Box
          sx={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography variant="h4" color="error" align="center" fontWeight={600} my={20}>
            {areasData
              ? `Error ${areasData?.status}: ${areasData?.statusText}`
              : 'Error, web no tiene data cargada'}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default Layout
